import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import BudgetMate from "./pages/BudgetMate";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import Layout from "./components/Layout";
import AdminLayout from "./components/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminSettings from "./pages/admin/AdminSettings";
import PrivacyPolicyR from "./pages/PrivacyPolicyR";

function App() {
  return (
    <Router>
      <Routes>
        {/* 🌐 Public Website */}

        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="budgetmate" element={<BudgetMate />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<TermsConditions />} />
          <Route path="privacyRozHisaab" element={<PrivacyPolicyR />} />
        </Route>

        {/* 🔐 Admin */}
        <Route path="/BudgetmateAdmin" element={<AdminLayout />}>
          <Route index element={<AdminLogin />} />

          <Route
            path="dashboard"
            element={
              <AdminProtectedRoute>
                <AdminDashboard />
              </AdminProtectedRoute>
            }
          />
          
            <Route path="/BudgetmateAdmin/settings" element={<AdminSettings />} /> ✅

          {/* <Route path="/admin/settings" element={<AdminSettings />} /> */}

        </Route>


      </Routes>
    </Router>
  );
}

export default App;
